import base from '@/__vue2stone/service/wasaapi/v1/__base';
import store from '@/store'
import axios from 'axios'

export default {
  createUrl() {
    const currentFactoryId = store.state.app.factory.id;
    return `v1/factory/${currentFactoryId}/factory_tag`
  },
  async index(params) {
    const currentFactoryId = store.state.app.factory.id;
    const res = await base.index({
      parentName: 'v2/factory',
      parentId: currentFactoryId,
      modelName: 'factory_tag',
      params,
    });
    return res;
  },
  async create(payload) {
    const currentFactoryId = store.state.app.factory.id;
    const res = await base.create({
      parentName: 'v1/factory',
      parentId: currentFactoryId,
      modelName: 'factory_tag',
      data: payload,
    })
    return res
  },
  async delete(id) {
    const currentFactoryId = store.state.app.factory.id;
    const params = {
      factory: currentFactoryId
    }
    const res = await base.delete({
      modelName: 'v1/factory_tag',
      modelId: id,
      params,
    })
    return res
  },
  async update(id, data) {
    const currentFactoryId = store.state.app.factory.id;
    try {
      const res = await axios.patch(
        `v1/factory_tag/${id}?factory=${currentFactoryId}`,
        data,
      )
      return res
    } catch (error) {
      alert(error)
    }
  },
  async show(tagId) {
    const params = {
      factory: store.state.app.factory.id,
    };
    const res = await base.show({
      modelName: 'v1/factory_tag',
      modelId: tagId,
      params,
    });
    return res;
  },
}